import { RangeBound } from 'gql/autogen/RangeBound';
import { FilterCode } from 'gql/autogen/FilterCode';

export enum DurationId {
    UpTo1Hour = 'UpTo1Hour',
    Between1And4Hours = '1To4Hour',
    Between4And244Hours = '4To24Hour',
    Between24And724Hours = '24To72Hour',
    MoreThan72Hours = 'MoreThan72Hour',
}

export const DurationCms: Record<DurationId, number> = {
    [DurationId.UpTo1Hour]: 147477,
    [DurationId.Between1And4Hours]: 147478,
    [DurationId.Between4And244Hours]: 150031,
    [DurationId.Between24And724Hours]: 147480,
    [DurationId.MoreThan72Hours]: 147481,
};

export enum BookingFeatureId {
    FreeCancellation = 'FreeCancellation',
    InstantConfirmation = 'InstantConfirmation',
}

export const BookingFeatureCms: Record<BookingFeatureId, number> = {
    [BookingFeatureId.FreeCancellation]: 411348,
    [BookingFeatureId.InstantConfirmation]: 411349,
};

export interface ValueFilterEvents {
    onValueFilterChange: (code: FilterCode, values: string[], selected: boolean) => void;
}

export interface RangeFilterEvents {
    onRangeFilterChange: (code: FilterCode, lowerBound: RangeBound, upperBound: RangeBound, selected: boolean) => void;
}

export interface ValueFilter {
    label: string;
    values: string[];
    selected: boolean;
    code: FilterCode;
}

export interface RangeFilter {
    label: string;
    selected: boolean;
    min: number;
    max: number;
    code: FilterCode;
}

export interface PriceFilterType {
    label: string;
    min: number;
    max: number;
    selectedMin: number;
    selectedMax: number;
    code: FilterCode;
}
